﻿import { HttpModule } from '@angular/http';

import { GlobalsComponent } from './debug/globals/globals.component';
import { NgModule } from '@angular/core';
import { PreloadAllModules, PreloadingStrategy, RouterModule, Routes } from '@angular/router';

import { DashboardView } from "./views/dashboard/dashboard.view";
import { MainComponent } from "./views/main/main.component";
import { AuthGuardService } from './services/auth-guard.service';
import { BlankView } from './views/blank/blank.view';
import { LicenseDetailsWindow } from './dialog-windows/license.details/license.details.window';
import { MemberDetailsWindow } from './dialog-windows/member.details/member.details.window'
import { EmailWindow } from './dialog-windows/email/email.window';
import { NoteWindow } from './dialog-windows/note/note.window';
import { TicketWindow } from './dialog-windows/ticket/ticket.window';
import { TicketAddWindow } from './dialog-windows/ticket.add/ticket.add.window';
import { ErrorsComponent } from './debug/errors/errors.component';


declare var System: any;

const appRoutes: Routes = [
    //main redirect
    { path: '', redirectTo: 'dashboard', pathMatch: 'full' },

    //dashboard views
    {
        path: 'dashboard', canActivate: [AuthGuardService], component: DashboardView,
        children: [
            { path: '', component: MainComponent },
            { path: 'home', component: MainComponent },
        ]
    },

    //new window dialogs
    {
        path: 'dialog-window', canActivate: [AuthGuardService], component: BlankView,
        children: [
            { path: '', component: LicenseDetailsWindow },
            { path: 'license', component: LicenseDetailsWindow },
            { path: 'member', component: MemberDetailsWindow },
            { path: 'ticket', component: TicketWindow },
            { path: 'ticket-add', component: TicketAddWindow },
            { path: 'email', component: EmailWindow },
            { path: 'note', component: NoteWindow },
        ]
    },

    //debug
    {
        path: 'debug', canActivate: [AuthGuardService], component: DashboardView,
        children: [
            { path: '', component: GlobalsComponent },
            { path: 'globals', component: GlobalsComponent },
            { path: 'errors', component: ErrorsComponent },
        ]
    },




    //handle all other routes
    { path: '**', redirectTo: 'dashboard' }


];


@NgModule({
    imports: [RouterModule.forRoot(appRoutes)],
    exports: [RouterModule]
})
export class AppRoutingModule { }
